// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"styles_contentWrapper__U7fYq","table":"styles_table__1IlS0","selectBlock":"styles_selectBlock__1hrLi","downloadButton":"styles_downloadButton__1xk9X"};